@import "stylesheets/sdx/typography/typography";

.component {
  position: relative;

  .bar-total,
  .bar-amount {
    border: 0.5 * $baseline solid;
    border-radius: 0.5 * $baseline;
  }
  .bar-total {
    width: 100%;
    border-color: $color-horizon;
  }
  .bar-amount {
    position: absolute;
    margin-top: -1 * $baseline;
  }

  .label {
    margin-top: 2px;
    @include typo-small;
    @include font-semi-light;

    b {
      @include font-semi-bold;
    }
  }

  &.sales {
    .bar-amount {
      border-color: $color-orchid;
    }
    .label {
      color: $color-orchid;
    }
  }

  &.standard,
  &.new {
    .bar-amount {
      border-color: $color-turquoise;
    }
    .label {
      color: $color-navy;
    }
  }
}

.component.sdx--dark-theme {
  .bar-total {
    border-color: rgb($color-white, 0.6);
  }

  &.sales {
    .bar-amount {
      border-color: $color-orchid-dark-theme;
    }
    .label,
    b {
      color: $color-orchid-dark-theme;
    }
  }

  &.standard,
  &.new {
    .bar-amount {
      border-color: $color-turquoise-dark-theme;
    }
    .label,
    b {
      color: $color-gray-dark-theme;
    }
  }
}
